export const environment = {
  production: true,
  name: 'PRODUCTION',
  apiUrls: {
    authApi: 'https://api-auth.mydocs.com.br/api/v1',
    coreApi: 'https://api-core.mydocs.com.br/api/v1',
    uploadApi: 'https://api-upload.mydocs.com.br/api/v1',
    ftpApi: 'https://api-ftp.mydocs.com.br/api/v1',
    documentServer: 'https://editor-of.mydocs.com.br',
  },
};
